import { graphql } from 'react-relay';
import type { CrmLists_Pagination_Query$variables } from './__generated__/CrmLists_Pagination_Query.graphql';

const BasicFragment = graphql`
  fragment CrmList_Basic_Fragment on CrmList {
    id
    title
    type
    content
    status
    statusSettings {
      ...Frags_Status_Settings_Fragment @relay(mask: false)
    }
    author {
      ...Frags_Wiz_Author_Fragment @relay(mask: false)
    }
    created
  }
`;

const SingleFragment = graphql`
  fragment CrmList_Single_Fragment on CrmList {
    ...CrmList_Basic_Fragment @relay(mask: false)
    crmListToItems(first: 100) {
      count
      edges {
        node {
          id
          listId
          itemId
          type
          mode
          created
          modified
          contact {
            node {
              ...Contact_Node_Fragment @relay(mask: false)
            }
          }
        }
      }
    }
  }
`;

export type CrmList_Pagination_Fragment$args = CrmLists_Pagination_Query$variables;
export type {
  CrmLists_Pagination_Query,
  CrmLists_Pagination_Query$variables,
} from './__generated__/CrmLists_Pagination_Query.graphql';
export * from './__generated__/CrmList_Pagination_Fragment.graphql';
export const CrmListsPaginationFragment = graphql`
  fragment CrmList_Pagination_Fragment on RootQuery
  @argumentDefinitions(
    first: { type: "Int" }
    after: { type: "String" }
    where: { type: "RootQueryToCrmListConnectionWhereArgs" }
  )
  @refetchable(queryName: "CrmLists_Pagination_Query") {
    crmLists(first: $first, after: $after, where: $where) @connection(key: "CrmList_Pagination_Fragment_Connection_crmLists") {
      __id
      edges {
        node {
          ...CrmList_Basic_Fragment @relay(mask: false)
        }
      }
    }
  }
`;

export * from './__generated__/CrmList_Query.graphql';
export const CrmListsQuery = graphql`
  query CrmList_Query {
    ...CrmList_Pagination_Fragment
      @arguments(
          first: 24
          after: null
          where: {
            search: null
            statusIn: [PUBLISH, DRAFT, PENDING]
            searchFields: [Title, Content]
            order: DESC
            orderBy: [Created]
          }
        )
  }
`;

export type {
  CrmList_Single_Query,
  CrmList_Single_Query$data,
  CrmList_Single_Query$variables,
} from './__generated__/CrmList_Single_Query.graphql';
export const CrmListSingleQuery = graphql`
  query CrmList_Single_Query($id: ID!) {
    crmList(id: $id) {
      ...CrmList_Single_Fragment @relay(mask: false)
    }
  }
`;

export type {
  CrmList_Select_Query,
  CrmList_Select_Query$data,
  CrmList_Select_Query$variables,
} from './__generated__/CrmList_Select_Query.graphql';
export const CrmListSelectQuery = graphql`
  query CrmList_Select_Query($where: RootQueryToCrmListConnectionWhereArgs) {
    ...CrmList_Pagination_Fragment @arguments(first: 100, after: null, where: $where)
  }
`;
